export const UPDATE_QUESTION_TITLE =
  'app/EditSessionPage/TlfbQuestion/UPDATE_QUESTION_TITLE';
export const UPDATE_HEAD_QUESTION =
  'app/EditSessionPage/TlfbQuestion/UPDATE_HEAD_QUESTION';
export const UPDATE_SUBSTANCE_QUESTION =
  'app/EditSessionPage/TlfbQuestion/UPDATE_SUBSTANCE_QUESTION';
export const UPDATE_SUBSTANCES_WITH_GROUP_TOGGLE =
  'app/EditSessionPage/TlfbQuestion/UPDATE_SUBSTANCES_WITH_GROUP_TOGGLE';

export const ADD_SUBSTANCE = 'app/EditSessionPage/TlfbQuestion/ADD_SUBSTANCE';
export const EDIT_SUBSTANCE = 'app/EditSessionPage/TlfbQuestion/EDIT_SUBSTANCE';
export const REMOVE_SUBSTANCE =
  'app/EditSessionPage/TlfbQuestion/REMOVE_SUBSTANCE';

export const ADD_SUBSTANCE_GROUP =
  'app/EditSessionPage/TlfbQuestion/ADD_SUBSTANCE_GROUP';
export const EDIT_SUBSTANCE_GROUP =
  'app/EditSessionPage/TlfbQuestion/EDIT_SUBSTANCE_GROUP';
export const ADD_SUBSTANCE_IN_GROUP =
  'app/EditSessionPage/TlfbQuestion/ADD_SUBSTANCE_IN_GROUP';
export const EDIT_SUBSTANCE_IN_GROUP =
  'app/EditSessionPage/TlfbQuestion/EDIT_SUBSTANCE_IN_GROUP';
export const REMOVE_SUBSTANCE_IN_GROUP =
  'app/EditSessionPage/TlfbQuestion/REMOVE_SUBSTANCE_IN_GROUP';
export const REMOVE_SUBSTANCE_GROUP =
  'app/EditSessionPage/TlfbQuestion/REMOVE_SUBSTANCE_GROUP';

export const maximumLength = 30;
